// 📁 Imports

import axios from "axios";
import { formValidator } from "@/utils/form-validator.js";
import {
  buttonSpinnerAdd,
  buttonSpinnerRemove,
} from "@/utils/button-spinner.js";
// import { alertShow } from "./alert.js";
import { modalShow, modalUpdateMessage } from "@/components/modal.js";
import { clearErrorMessage } from "@/utils/input-message.js";

// 💾 Variables
const forms = document.querySelectorAll("[data-form-submit]");

// 📐 Functions
const formSend = async (form) => {
  const formData = serializeFormToJSON(form);
  const formAction = form.dataset.formPost;
  const modal = form.querySelector("[data-modal]");
  const formSubmitButton = document.querySelector(
    `[data-form-submit=${form.dataset.form}]`,
  );

  if (formSubmitButton) {
    buttonSpinnerAdd(formSubmitButton);
  }

  try {
    const response = await axios.post(
      `${formAction}`,
      JSON.stringify(formData),
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    console.log("Success response", response.data);

    window.dispatchEvent(
      new CustomEvent("onSubmitForm", {
        detail: {
          message: response.data.messages,
        },
      }),
    );

    if (modal) {
      modalUpdateMessage(modal, response.data.messages);
      modalShow(modal);
      formReset(form);
    }

    if (formSubmitButton) {
      buttonSpinnerRemove(formSubmitButton);
    }

    return response;
  } catch (error) {
    console.log("error", error.data);
    if (modal) {
      modalUpdateMessage(modal, error.data.messages);
      modalShow(modal);
    }

    if (formSubmitButton) {
      buttonSpinnerRemove(formSubmitButton);
    }
  }
};

// Form reset (reset values for all inputs)
const formReset = (form) => {
  const formInputs = form.querySelectorAll(
    "input:not([type='hidden']):not(.antispamanswer), textarea",
  );

  formInputs.forEach((input) => {
    clearErrorMessage(input);
    if (
      input.type === "text" ||
      input.type === "email" ||
      input.type === "tel" ||
      input.type === "number" ||
      input.tagName.toLowerCase() === "textarea"
    ) {
      input.value = "";
    }

    if (input.type === "checkbox" || input.type === "radio") {
      input.checked = false;
    }
  });
};

const serializeFormToJSON = (form) => {
  const inputs = form.querySelectorAll("input, select, textarea");
  const data = {};

  inputs.forEach((input) => {
    const { name, type } = input;

    if (!name || input.disabled) return;

    switch (type) {
      case "checkbox":
        if (input.checked) {
          if (!data[name]) data[name] = [];
          data[name].push(input.value);
        }
        break;

      case "radio":
        if (input.checked) {
          data[name] = input.value;
        }
        break;

      default:
        data[name] = input.value;
    }
  });

  for (const key in data) {
    if (Array.isArray(data[key]) && data[key].length === 1) {
      data[key] = data[key][0];
    } else if (
      typeof data[key] === "string" &&
      data[key].startsWith("[") &&
      data[key].endsWith("]")
    ) {
      data[key] = JSON.parse(data[key]);
    }
  }

  console.log("data", data);

  return data;
};

// 🖱️ Event listener
if (forms.length !== 0) {
  Array.from(forms).forEach((form) => {
    form.addEventListener("click", (e) => {
      const formIdentificator = e.currentTarget.dataset.formSubmit;
      const formIsValid = formValidator(formIdentificator).isValid;
      const formValidation = formValidator(formIdentificator).el;
      console.log(formIsValid);
      if (formIsValid) {
        console.log("Form is valid");
        formSend(formValidation);
      }
    });
  });
}

// 📤 Export
export { formSend, formReset };
